import { ArrowDropDown } from '@mui/icons-material'
import { Button, Menu, MenuItem } from '@mui/material'
import { SortIndexField } from '__generated__/graphql'
import React, { FC, useState } from 'react'
import { useCandidateSqlSearch } from 'client/candidate-table-temp/hooks/useCandidateSqlSearch'

/**
 * Header component for the Name column with dropdown menu
 */
export const NameColumnHeader: FC = () => {
    const { activeSortFields, setActiveSortFields } = useCandidateSqlSearch()

    if (activeSortFields === undefined || activeSortFields === null) {
        throw new Error(
            `NameColumnHeader: activeSortFields is ${activeSortFields} when it should be an array.`
        )
    }

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleSort = (
        field: SortIndexField | null,
        order: 'asc' | 'desc' | null
    ) => {
        if (field && order) {
            setActiveSortFields([{ field, order }])
        } else {
            setActiveSortFields([])
        }
        handleClose()
    }

    const nameSort = activeSortFields.find(
        (sort) =>
            sort.field === SortIndexField.FirstName ||
            sort.field === SortIndexField.LastName
    )

    let currentLabel = 'Name'
    if (nameSort) {
        if (nameSort.field === SortIndexField.FirstName) {
            currentLabel =
                nameSort.order === 'asc'
                    ? 'Name (First A-Z)'
                    : 'Name (First Z-A)'
        } else if (nameSort.field === SortIndexField.LastName) {
            currentLabel =
                nameSort.order === 'asc' ? 'Name (Last A-Z)' : 'Name (Last Z-A)'
        }
    }

    return (
        <>
            <Button
                onClick={handleClick}
                endIcon={<ArrowDropDown />}
                sx={{
                    textTransform: 'none',
                    color: 'text.primary',
                    fontSize: '0.875rem',
                    minWidth: 'auto',
                    padding: 0,
                    backgroundColor: 'transparent',
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                    '&:active': {
                        backgroundColor: 'transparent',
                    },
                }}
            >
                {currentLabel}
            </Button>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <MenuItem onClick={() => handleSort(null, null)}>Name</MenuItem>
                <MenuItem
                    onClick={() => handleSort(SortIndexField.FirstName, 'asc')}
                >
                    Name (First A-Z)
                </MenuItem>
                <MenuItem
                    onClick={() => handleSort(SortIndexField.FirstName, 'desc')}
                >
                    Name (First Z-A)
                </MenuItem>
                <MenuItem
                    onClick={() => handleSort(SortIndexField.LastName, 'asc')}
                >
                    Name (Last A-Z)
                </MenuItem>
                <MenuItem
                    onClick={() => handleSort(SortIndexField.LastName, 'desc')}
                >
                    Name (Last Z-A)
                </MenuItem>
            </Menu>
        </>
    )
}
